import { GridToolbarContainer, GridToolbarExport } from "@mui/x-data-grid";
import { Typography, Box } from "@mui/material";
import { GoToPageControls } from "./GoToPageToolbar"; // ✅ added

function CustomToolbar({ tableTitle, defaultExport = false }) {
  const DataGridCustomToolbar = ({ totalPages, onPageChange }) => {
    return (
      <GridToolbarContainer
        style={{
          display: "flex",
          justifyContent: "space-between",
          padding: "1em",
          borderBottom: "1px solid lightgray",
          height: "4.2em",
        }}
      >
        <Typography variant="h6">{tableTitle}</Typography>
        <Box display="flex" alignItems="center" gap={1}>
          <GoToPageControls
            totalPages={totalPages}
            onPageChange={onPageChange}
          />
          <>
            {defaultExport ? (
              <GridToolbarExport
                printOptions={{ disableToolbarButton: true }}
              />
            ) : (
              <div />
            )}
          </>
        </Box>
      </GridToolbarContainer>
    );
  };
  return DataGridCustomToolbar;
}

const getDataGridToolbarProps = (tableTitle, exportOption = false) => {
  return CustomToolbar({
    tableTitle: tableTitle,
    defaultExport: exportOption,
  });
};

export default getDataGridToolbarProps;
